import axios from 'axios';
import config from '../config'
import cookie from 'react-cookies'
import { message } from 'antd';

var instance = axios.create({
    baseURL: config.SERVER + '/api/v1'
});
//添加请求拦截器
instance.interceptors.request.use(
    // 设置请求头
    config => {
        if (cookie.load('_tkn_')) {
            config.headers.Authorization = 'Bearer ' + cookie.load('_tkn_');
        }
        if (config.method === 'get') {
            config.params = {
                _t: new Date().getTime(),
                ...config.params
            }
        }
        return config
    },
    error => {
        return Promise.reject(error);
    }
)
// 响应拦截器
instance.interceptors.response.use(
    response => {
        // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
        // 否则的话抛出错误
        if (response.status === 200) {
            if(response.data.resultCode !== 1){
                message.warning(response.data.resultMessage)
            }
            switch (response.data.resultCode) {
                case -2:
                case -4:
                case -5:
                case -6:
                case -7:
                    window.location.replace("/")
                    break;
                default:
                    break;
            }
            return Promise.resolve(response.data);
        }
    },
    // 服务器状态码不是2开头的的情况
    // 这里可以跟你们的后台开发人员协商好统一的错误状态码
    // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
    // 下面列举几个常见的操作，其他需求可自行扩展
    error => {
        if (error.response && error.response.status) {
            console.info(error)
            switch (error.response.status) {
                // 401: 未登录
                case 401:
                    window.location.replace("/")
                    return Promise.resolve({ status: 200, data: { resultCode: -2, resultMessage: '登录状态失效，重新登录' } });
                case 429:
                    return Promise.resolve({ status: 200, data: { resultCode: -2, resultMessage: error.response.data } });
                case 403:
                    window.location.replace("/")
                    return Promise.resolve({ status: 200, data: { resultCode: -2, resultMessage: '登录状态失效，重新登录' } });
                // // 404请求不存在
                // case 404:
                //     return Promise.resolve({ status: 200, data: { resultCode: 1, resultMessage: '网络请求不存在' } });
                // // 其他错误，直接抛出错误提示
                // default:
                //     return Promise.resolve({ status: 200, data: { resultCode: 1, resultMessage: '未知错误：'+error.response.status +':'+ error.response.data} });
            }
            // return Promise.reject(error.response);
        } else {
            message.warning('网络请求失败：'+error)
            return Promise.resolve({ status: 200, data: { resultCode: -1, resultMessage: '网络请求失败：'+error} });
        }
    });


export default class request {
    static post(api, data) {
        return new Promise(function (resolve, reject) {
            return instance.post(api, data)
                .then((response) => {
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
        });
    }
    static get(api, params) {
        return new Promise(function (resolve, reject) {
            return instance.get(api, { params: params })
                .then((response) => {
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
        });

    }

    static delete(api, params) {
        return new Promise(function (resolve, reject) {
            return instance.delete(api, {params})
                .then((response) => {
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });
        });

    }
}


